<ng-template #popGiphyTemplate>
    <sb-giphy-popover (add)="addGifAttachment($event)"></sb-giphy-popover>
</ng-template>

<button
    id="giphy-picker"
    class="btn btn-icon"
    type="button"
    [popover]="popGiphyTemplate"
    placement="top"
    containerClass="giphy-popover"
    container="body"
    tooltip="{{ 'Gif' | translate }}"
    #giphyPopover="bs-popover"
    [disabled]="isDisabled"
    [outsideClick]="true">
    <sb-inline-svg
        class="icon p-0"
        [attr.aria-label]="'Gif' | translate"
        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Gif.svg'">
    </sb-inline-svg>
</button>
